module.exports = __webpack_public_path__ + "static/media/IMG_2934.29f01971.jpg";